import { Link } from 'react-router-dom';
import { tvShows } from '@/mocks/tvShows';
import ShowCard from '@/components/base/ShowCard';
import SectionTitle from '@/components/base/SectionTitle';

export default function PopularShows() {
  const popular = tvShows.filter((s) => s.featured || s.rating >= 9.0).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionTitle
          title="热门美剧推荐"
          subtitle="评分最高的经典与热门美剧，每一部都值得追"
          href="/category/all"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {popular.map((show) => (
            <ShowCard key={show.id} show={show} />
          ))}
        </div>
      </div>
    </section>
  );
}